import { Question } from 'src/types/questionnaire.types';

export const QUESTIONNAIRE_MOCK: Question[] = [
  {
    id: '1',
    title: 'When were you first prescribed Vydura?',
    type: ['date-choice'],
  },
  {
    id: '2',
    title: 'What day did you first take Vydura?',
    type: ['date-choice'],
  },
  {
    id: '3',
    title: 'How many Vydura doses do you have left?',
    type: ['input'],
  },
  {
    id: '4',
    title: 'Have you scheduled a follow-up appointment with your doctor?',
    type: ['single-choice', 'date-time-selection', 'option-selection'],
    choices: [
      { id: '1', title: 'Yes' },
      { id: '0', title: 'No' },
    ],
    selections: [
      { id: '1', title: 'Neurologist' },
      { id: '2', title: 'General practitioner' },
      { id: '3', title: 'Other' },
    ],
    isDoctorAppointmentCreation: true,
  },
  {
    id: '5',
    title:
      'How many days per month on average over the last 3 months have you had a migraine attack?',
    type: ['single-choice'],
    choices: [
      { id: '1', title: '0-3 days' },
      { id: '2', title: '4-7 days' },
      { id: '3', title: '8-14 days' },
      { id: '4', title: '15+ days' },
    ],
  },
  {
    id: '6',
    title: 'Your prescription for Vydura is to be used:',
    type: ['single-choice'],
    choices: [
      { id: '1', title: 'Every other day' },
      { id: '2', title: 'Once per attack' },
      { id: '3', title: 'Both' },
    ],
  },
  {
    id: '7',
    title: 'What is your age?',
    type: ['single-choice'],
    choices: [
      { id: '1', title: '18-24' },
      { id: '2', title: '25-34' },
      { id: '3', title: '35-44' },
      { id: '4', title: '45-54' },
      { id: '5', title: '55-64' },
      { id: '6', title: '65 and over' },
    ],
  },
];
